module.exports = __webpack_public_path__ + "img/osho_image.64594efe.jpg";